import React, {
	memo,
	useCallback,
	useState
} from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	Header,
	Icon,
	Modal
} from 'semantic-ui-react';

import { log } from '../../services/utils';

const AlertModal = ( {
	action,
	actionColor,
	actionText,
	closeModal,
	closeText,
	heading = '',
	hideActions,
	icon,
	iconColor,
	id,
	message = '',
	open,
	...props
} ) => {
	const [ actionLoading, setActionLoading ] = useState( false );
	const [ closeLoading, setCloseLoading ] = useState( false );

	const handleAction = useCallback( async () => {
		setActionLoading( true );
		await action();
		await closeModal();
		setActionLoading( false );
	}, [
		action,
		closeModal
	] );

	const handleClose = useCallback( async () => {
		setCloseLoading( true );
		await closeModal();
		setCloseLoading( false );
	}, [ closeModal ] );

	return (
		<Modal
			id={ id }
			open={ open }
			onClose={ closeModal }
			size="mini"
			{ ...props }
		>
			{ log( `- ${ id }` ) }
			{ heading
				? (
					<Modal.Header>
						<Header
							as="h3"
							style={ {
								display: 'flex',
								alignItems: 'center'
							} }
						>
							<Icon
								name={ icon }
								color={ iconColor }
								size="tiny"
								style={ { fontSize: '1.75rem' } }
							/>
							{ heading }
						</Header>
					</Modal.Header>
				)
				: null
			}
			<Modal.Content>
				<Modal.Description>{ message }</Modal.Description>
			</Modal.Content>
			{ hideActions
				? null
				: (
					<Modal.Actions>
						<Button
							content={ closeText }
							loading={ closeLoading }
							onClick={ handleClose }
							size="small"
						/>
						{ action
							? (
								<Button
									color={ actionColor }
									content={ actionText || 'Confirm'}
									onClick={ handleAction }
									size="small"
									loading={ actionLoading }
								/>
							)
							: null
						}
					</Modal.Actions>
				)
			}
		</Modal>
	);
};

AlertModal.propTypes = {
	action: PropTypes.func,
	actionColor: PropTypes.string,
	actionText: PropTypes.string,
	closeModal: PropTypes.func.isRequired,
	closeText: PropTypes.string,
	heading: PropTypes.string,
	hideActions: PropTypes.bool,
	icon: PropTypes.string,
	iconColor: PropTypes.string,
	id: PropTypes.string,
	message: PropTypes.node.isRequired,
	open: PropTypes.bool.isRequired
};

export default memo( AlertModal );
